import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://c93ee871b2534ca785154b2d145adf0d@glitchtip.cimpleo.com/1',
  release: process.env.NEXT_PUBLIC_COMMIT_SHA,
  environment: process.env.NODE_ENV,
  tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,
  maxBreadcrumbs: 50,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
